/**
 * Detekuje, zda se ma nastavit hodnota atributu crossOrigin na 'Anonymous'
 * TODO: dalo by se porovnavat location.host, zda je stejne s URL
 */
export const getCrossOriginValue = (url) => {
    if (!url) {
        return undefined;
    }
    url = url.trim().toLowerCase();
    return url.indexOf('http') === 0 || url.indexOf('//') === 0 ? 'Anonymous' : undefined;
};
//# sourceMappingURL=getCrossOriginValue.js.map